const ordinal = (n) => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;

  return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

// Renders a payout batch date as "Tue, May 30th, 2024" to match the design.
export const formatPromotionDate = (value) => {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
  const month = date.toLocaleDateString('en-US', { month: 'long' });

  return `${weekday}, ${month} ${ordinal(date.getDate())}, ${date.getFullYear()}`;
};

// Extracts the BE error message with a per-call fallback.
export const parseErrorMessage = (
  error,
  fallback = 'Something went wrong. Please try again.',
) => error?.response?.data?.message || fallback;

// "1 Payout" / "2 Payouts".
export const pluralPayouts = (count) => `${count} Payout${count === 1 ? '' : 's'}`;
